import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VwCommissionPanelModel } from 'src/app/model/vw-commission-panel.model';
import { DataTableDirective } from 'angular-datatables';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { ModalAlertComponent } from 'src/oldApp/shared/modal-alert/modal-alert.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-commission-configuration',
  templateUrl: './modal-commission-configuration.component.html',
  styleUrls: ['./modal-commission-configuration.component.css']
})
export class ModalCommissionConfigurationComponent implements OnInit {
  @Input() header:string;
  @Input() text:string;
  @Input() acceptText:string;
  @Input() cancelText:string;
  @Input() tableItemsFiltered:VwCommissionPanelModel[];
  @Input() selectedEmployeeJobs:CatalogModel[]=[];
  @Input() selectedSchemas:CatalogModel[]=[];

  public viewStatus:number=0;
  public viewPromotion:number=0;
  public viewCommisision:number=0;
  public promotionCatalog:CatalogModel[]=[];
  public selectedPromotions:any[]=[];
  public commission:number=null;
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                         // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},  // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  // Opciones de Datatable
  @ViewChild(DataTableDirective, {static: false})
  private datatableElement: DataTableDirective;

  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      // { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 5,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  ////////////////
  constructor(
    private modalService: NgbModal, private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.viewStatus = 1;
    if(this.selectedEmployeeJobs.length>0 && this.selectedSchemas.length>0){
      let employeeId = this.selectedEmployeeJobs[0].id;
      let schemaId = this.selectedSchemas[0].id;
      if((employeeId===1 || employeeId===2) && schemaId === 5){
        this.viewCommisision=1;
        //this.getPromotions();
      }
      if((employeeId===1 || employeeId===2) && (schemaId === 3 || schemaId === 5)){
        this.viewPromotion=1;
      }
    }
  }

  commissionError=()=> this.commission!==0 && !this.commission;

  commissionChange=e=> this.commission=Number(e);

  promotionChange=e=> {
    this.selectedPromotions=e;
  };

  getPromotions=()=>{

  }

  //
  accept=()=> {
    if(this.viewCommisision===1){

      if(this.commission != null && this.commission> 0){

        let items=this.tableItemsFiltered.filter(it=> it.selected);
        items.forEach((it, ind)=> {
          it.commission=this.commission;
        });
        console.log(">> Selected Items= ", items);
        this.modalService.dismissAll(items);

      }else{
        this.toastr.error('Ingrese el porcentage de Comisón!');

        // let modalRef=this.modalService.open(ModalAlertComponent, {centered:true, size:'sm', backdrop:'static', keyboard:false});
        // modalRef.componentInstance.text='Ingrese el porcentage de Comisón!';
        // modalRef.result.then(
        //   data=> console.log(data),
        //   reason=> {
        //     if(reason ==='accept') {
        //     }
        //   }
        // );

        return;
      }
    }else{
      let items=this.tableItemsFiltered.filter(it=> it.selected);
      items.forEach((it, ind)=> {
        it.commission=0;
      });
      console.log(">> Selected Items= ", items);
      this.modalService.dismissAll(items);
    }
  }

  cancel=()=> {
    this.modalService.dismissAll(null);
  }

  makeTableColumns=()=> {
    let columns=[
      {title:'', data:function(data) {
        return '<div class="custom-control custom-checkbox custom-control-solid">'+
            '<input type="checkbox" class="custom-control-input select-row" id="customCheck-'+data.commissionId+'" '+(data.selected?'checked':'')+'>'+
            '<label class="custom-control-label" for="customCheck-'+data.commissionId+'"></label>'+
        '</div>'
      }},

      // {title:'Id', data:'commissionId'},
      {title:'Línea de Negocio', data:'businessProductDesc'},
      {title:'Tipo de Fondeo', data:'ownerTypeDesc'},
      {title:'Producto', data:'financingTypeDesc'},
      {title:'Convenio', data:'afiliateDesc'},
      //{title:'Promoción', data:'promotionId'},
      {title:'Plazo', data:'paymentDesc'},
      {title:'Categoría', data:'productCategoryDesc'},
      {title:'Puesto', data:'employeeJobDesc'},
      {title:'Esquema', data:'schemaDesc'},
      // {title:'Comisión', data:function(data) {
      //   return data.commission?data.commission+'%':''
      // }},

      {title:'', data:function(data) {
        let active=data.activeId?'<span class="text-success"><i class="icon-ok-squared"></i></span>':
          '<span class="text-danger"><i class="check-empty"></i></span>';
        let database=data.commissionId>0?'<span class="text-info"><i class="icon-database"></i></span>':'';
        return active+database;
      }, className:''}
    ];
    return columns;
  }

}
